export default {
  en: {
    'new_game': 'new game',
    'load_game': 'load game',
    'create_new_game': 'create new game',
    'game_name': 'game name',
    'name': 'name',
    'short_name': 'short name',
    'is_required': 'is required',
    'no_saved_games_yet': 'No saved games yet.',
    'back': 'back',
    'load': 'load',
    'saved': 'saved',
    'last_updated_at': 'last updated at: {date}',
    'last_created_at': 'last created at: {date}',
    'sure_you_want_to_delete_it?': 'Sure you want to delete it?',
    'sure_you_want_to_override_it?': 'Sure you want to override it?',
    'auto': 'auto',
    'auto_saving...': 'auto saving...',
    'saving...': 'saving...',
    'save_game': 'save game',
    'save_to_new_slot': 'save to new slot',
    'delete': 'delete',
    'override': 'override',
    'loading...': 'loading...',
    'done': 'done',
    'select_a_country': 'select a country',
    'create': 'create',
    'primary_color': 'primary color',
    'secondary_color': 'secondary color',
    'creating_game': 'creating game',
    '': '',
  }
};